__webpack_require__.p = "https://mindverseglobal.mindverse.com/front-packaged/mindcommerse/pre_k8s/packaged-files/_next/";